import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// Model

export class HotelContactModel {
  id: string;
  name: string;
  phone: string;
  email: string;
  description: string;
}

export class HotelRoomModel {
  id: string;
  type: string;
  size: string;
  description?: string | null;
}

export class HotelLiteModel extends CommonModel {
  area: string;
  description?: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  phone_2?: string | null;

  @Expose({ name: 'year_founded' })
  yearFounded: string;

  @Expose({ name: 'city_country' })
  cityCountry: string;

  // @Type(() => HotelContactModel)
  // contact: HotelContactModel | null;
}

export class HotelModel extends HotelLiteModel {
  preferences: string[];

  @Expose({ name: 'check_in' })
  checkIn: string;

  @Expose({ name: 'check_out' })
  checkOut: string;

  @Expose({ name: 'hotel_rooms' })
  @Type(() => HotelRoomModel)
  hotelRooms: HotelRoomModel[];

  regulation: string;

  @Expose({ name: 'mandatory_fee' })
  mandatoryFee: string;

  // @Type(() => HotelContactModel)
  // contact: HotelContactModel;
}

// Input

export type getHotelsInput = {
  params: CommonParamInput;
};

export type getHotelInput = {
  id: string;
};

export type HotelContactInput = {
  id?: string;
  name: string;
  phone: string;
  email: string;
  description: string;
};

export type HotelRoomItemInput = {
  id?: string;
  type: string;
  size: string;
  description?: string | null;
};

export type HotelMutationInput = {
  // REQUIRED
  area: string;
  email: string;
  phone: string;
  name: string;
  cityCountry: string;
  address: string;
  yearFounded: string;
  // contact: HotelContactInput;
  hotelRooms: HotelRoomItemInput[];
  preferences: string[];

  description?: string;
  regulation?: string;
  mandatoryFee?: string;
};

export type HotelUpdateInput = {
  hotelId: string;
  body: HotelMutationInput;
};

export type HotelDeleteInput = {
  hotelId: string;
};
